import { generatePath } from "~/utils/generatePath";

/**
 * URLパスからレポートタイプを判定し、DealReportImageのSWRキーを生成する
 * @param url - URLパス（'/deals/:deal_id/inspection_reports', '/vendors/deals/:deal_id/inspection_reports', '/deals/:deal_id/completion_reports', '/vendors/deals/:deal_id/completion_reports'）
 * @param dealId - 案件ID
 * @returns SWRキー文字列
 */
export const getReportImageSwrKey = (url: string, dealId: number): string => {
	const reportPattern = /^\/(vendors\/)?deals\/[0-9]+\/([a-z]+)_reports/;
	const match = reportPattern.exec(url);
	if (!match) throw new Error(`Invalid URL format: ${url}`);

	const isVendor = !!match[1]; // 'vendors/' がマッチしたか
	const reportType = match[2]; // 'inspection'または'completion'を期待

	if (reportType !== "inspection" && reportType !== "completion") {
		throw new Error(
			`Invalid report type: ${reportType}. Expected 'inspection' or 'completion'.`
		);
	}

	if (isVendor) {
		return reportType === "inspection"
			? generatePath("/vendors/deals/:deal_id/deal_inspection_report_images", {
					deal_id: dealId
				})
			: generatePath("/vendors/deals/:deal_id/deal_completion_report_images", {
					deal_id: dealId
				});
	}

	return reportType === "inspection"
		? generatePath("/deals/:deal_id/deal_inspection_report_images", {
				deal_id: dealId
			})
		: generatePath("/deals/:deal_id/deal_completion_report_images", {
				deal_id: dealId
			});
};
